const INITIAL_CART_CONTEXT_STATE = {
  cartIsOpen: false,
  toggleCartOpening: () => null,
  addMultipleCards: () => null,
  getInitialCards: async ({ userID }) => null,
  emptyCart: async ({ userID }) => null,
  removeCard: async ({ userID, listingUUID, brandUUID }) => null,
  setAffiliateUrl: async () => null,
  clearErrorMessage: () => null,
  cart: {
    isCartLoading: false,
    cards: [],
    cartUuid: null,
    total: null,
    errorMessage: null,
    totalSavings: null,
    isInitialCardsLoaded: false,
    secondsLeft: null,
    timeLeft: null,
    timeIsUp: false,
    affiliateUrl: null
  }
};

const CARD_DETAILS_CONSTANTS = {
  cardDetails: [
    "Free delivery",
    "Gift cards cannot be used to purchase other gift cards"
  ]
};

const CARD_TYPES = {
  EGIFT: "egift",
  VOUCHER: "voucher",
  PHYSICAL: "physical"
};

const TOOLTIP_CONSTANTS = {
  egift: "Electronic delivery for online use only",
  voucher: "Can be printed and redeemed in-store",
  physical: "Delivered by mail for use in-store"
};

const DELIVERY_AND_REDEMPTION_INSTRUCTIONS = {
  egift: "This eGift card can be redeemed online.",
  voucher: "This printable voucher can be redeemed on location.",
  eletronicOrVoucher:
    "Most eGift cards and printable vouchers are delivered to your GCX account instantly, but please allow up to 24 hours."
};

const CART_CONFIG = {
  MAX_CART_SIZE: 25,
  MAX_CART_VALUE: 100000,
  ENABLE_PRE_VALIDATION: true,
  ENABLE_POST_VALIDATION: true
};

const VALIDATION_MESSAGES = {
  MAX_CART_VALUE: (
    value
  ) => `Sorry, you may not purchase more than ${value} worth of gift cards per day.
    Please update your cart to proceed.`,
  MAX_CART_SIZE: (
    value
  ) => `Sorry, you may not purchase more than ${value} gift cards in a single order.
    Please update your cart to proceed.`
};

const SAVINGS_OPERATIONS = {
  ADD: (currentValue, newValue) => currentValue + newValue
};

const SOURCE_METHODS = {
  REMOVE_CARD: "removeCard",
  GET_CARDS: "getCards",
  EMPTY_CART: "emptyCart",
  ADD_CARDS: "addMultipleCards"
};

export {
  CARD_DETAILS_CONSTANTS,
  CARD_TYPES,
  CART_CONFIG,
  DELIVERY_AND_REDEMPTION_INSTRUCTIONS,
  INITIAL_CART_CONTEXT_STATE,
  TOOLTIP_CONSTANTS,
  VALIDATION_MESSAGES,
  SAVINGS_OPERATIONS,
  SOURCE_METHODS
};
